import * as React from 'react';

import NewArtifactType from './NewArtifactType';
import ProjectArtifactTypes from './ProjectArtifactTypes';
import ArtifactType from './ArtifactType';
import {PanelExportContextProvider} from './Panel2/PanelExportContext';

import '../css/Artifacts.less';
import makeComp from '../util/profiler';

interface ProjectArtifactsTabProps {
  entityName: string;
  projectName: string;
  artifactTypeName?: string;
  artifactCollectionName?: string;
  artifactCommitHash?: string;
  artifactTab?: string;
  filePath?: string;
  history: any;
}

const ProjectArtifactsTab = makeComp(
  (props: ProjectArtifactsTabProps) => {
    const {
      entityName,
      projectName,
      history,
      artifactCommitHash,
      artifactTab,
      filePath,
    } = props;
    const artifactTypeName =
      props.artifactTypeName != null
        ? decodeURIComponent(props.artifactTypeName)
        : undefined;

    const artifactCollectionName =
      props.artifactCollectionName != null
        ? decodeURIComponent(props.artifactCollectionName)
        : undefined;
    // We're basically doing our own routing. There's probably a way to do this
    // by nesting react router or something

    if (artifactTypeName != null) {
      if (artifactTypeName === 'new') {
        return (
          <NewArtifactType
            entityName={entityName}
            projectName={projectName}
            history={history}
          />
        );
      }

      return (
        <ArtifactType
          entityName={entityName}
          projectName={projectName}
          artifactTypeName={artifactTypeName}
          artifactCollectionName={artifactCollectionName}
          artifactCommitHash={artifactCommitHash}
          artifactTab={artifactTab}
          filePath={filePath}
          history={props.history}
        />
      );
    }
    return (
      <ProjectArtifactTypes
        entityName={entityName}
        projectName={projectName}
        artifactTypeName={artifactTypeName}
      />
    );
  },
  {id: 'ProjectArtifactsTab'}
);

const ProjectArtifactsTabWithClass = makeComp(
  (props: ProjectArtifactsTabProps) => {
    return (
      <div className="artifacts">
        <PanelExportContextProvider>
          <ProjectArtifactsTab {...props} />
        </PanelExportContextProvider>
      </div>
    );
  },
  {id: 'ProjectArtifactsTabWithClass'}
);

export default ProjectArtifactsTabWithClass;
